module.exports = __webpack_public_path__ + "static/red_ahead-abd1a6c8bdbcb7137cc3f4b67034907f.png";